// Say something when a click fails — the web twin of
// mobile/src/utils/actionError.ts.
//
// A 2026-09-24 audit found web buttons (join / leave a community, like,
// save, delete a pool, archive a bracket, rename a matchup option, vote
// in a bracket, Quick Vote) whose failure went only to the console: the
// click did nothing — or quietly undid itself — and nothing said why.
// Each now calls notifyActionFailed, and <ActionToast/> (mounted once in
// App.js) shows "Couldn't <action>".

export const ACTION_FAILED_EVENT = 'matchup:action-failed';

// Server messages are shown only for errors the USER can act on.
// Internal / unknown errors carry driver text ("pq: …") that means
// nothing to a person and shouldn't be on screen.
const USER_FACING_CODES = new Set([
  'invalid_argument',
  'failed_precondition',
  'permission_denied',
  'not_found',
  'already_exists',
  'resource_exhausted',
  'out_of_range',
]);

// The backend blocks following and creating content until the email is
// verified (FailedPrecondition, "verify your email …").
const isVerifyGateError = (err) => /verif/i.test(String(err?.response?.data?.message ?? ''));

// `action` completes "Couldn't <action>" — e.g. 'join this community'.
export function describeActionFailure(action, err) {
  if (isVerifyGateError(err)) {
    return {
      title: 'Verify your email first',
      detail: `Verify your email to ${action}. Check your inbox for the link.`,
      verifyGate: true,
    };
  }
  const code = String(err?.response?.data?.code ?? '');
  const msg = String(err?.response?.data?.message ?? '').trim();
  const detail =
    USER_FACING_CODES.has(code) && msg && msg.length <= 160
      ? msg.charAt(0).toUpperCase() + msg.slice(1)
      : 'Check your connection and try again.';
  return { title: `Couldn’t ${action}`, detail };
}

export function notifyActionFailed(action, err) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(ACTION_FAILED_EVENT, { detail: describeActionFailure(action, err) }),
  );
}
